import {
  AvatarGroup,
  Avatar,
  IconDropDownButton,
} from "@etframework/ui.components";
import {
  useBoard,
  useBoardPermissions,
} from "../../../data/queries/boardQueries";
import { useTranslation } from "react-i18next";
import useModalEvent from "../../../hooks/useModalEvent";
import { TaskTypeHeaderBoardInformation } from "./TaskTypeHeaderBoardInformation";
import { toast } from "react-toastify";
import { useUpdateBoard } from "../../../data/mutations/boardMutations";
import { useQueryClient } from "@tanstack/react-query";
import Enums from "../../../types/enums";

export const TaskTypeBoardHeader = ({ boardId }) => {
  const { t } = useTranslation(["TaskTypes", "Boards"]);
  const { data: boardPermissions } = useBoardPermissions(boardId);
  const { data: board } = useBoard(boardId);
  const { mutate: updateBoard } = useUpdateBoard();
  const queryClient = useQueryClient();

  const { ModalEvents, toggleModal } = useModalEvent();

  const usersBoardPermissions = boardPermissions?.Entities?.filter(
    (item) => item.PermissionType === Enums.PermissionType.User
  )?.length;
  const groupsBoardPermissions = boardPermissions?.Entities?.filter(
    (item) => item.PermissionType === Enums.PermissionType.Group
  )?.length;

  let dropdownMenu = [
    {
      id: "dd_settings_board-settings_title-row_actions-menu_archive-board",
      text: board?.Archived
        ? t("Boards:RestoreTaskBoard")
        : t("Boards:ArchiveTaskBoard"),
      iconCss: "fa-regular fa-archive",
      onClick: () => {
        if (board?.Archived) onUpdateArchivedBoard();
        else toggleModal(ModalEvents.ArchiveBoardConfirmationModal);
      },
    },
  ];

  if (!board?.IsDefault) {
    dropdownMenu = [
      ...dropdownMenu,
      {
        id: "dd_settings_board-settings_title-row_actions-menu_delete-board",
        text: t("Boards:DeleteTaskBoard"),
        iconCss: "fa-regular fa-trash-can",
        onClick: () => {
          toggleModal(ModalEvents.DeleteBoardConfirmationModal);
        },
      },
    ];
  }

  const onUpdateArchivedBoard = () => {
    let board = {
      Id: boardId,
      Archived: false,
    };

    updateBoard(
      { board: board },
      {
        onSuccess: () => {
          queryClient.invalidateQueries(["get-board", boardId]);
          toast.success(t("Boards:ArchiveBoardModal.ArchivedUpdated"), {
            position: "bottom-left",
          });
        },
        onError: () => {
          toast.error(t("Boards:ArchiveBoardModal.ErrorMsg"), {
            position: "bottom-left",
          });
        },
      }
    );
  };

  const onSelectDropDownTaskMenu = (args) => {
    args?.item?.onClick?.();
  };

  const onClickOpenAccessModal = () => {
    toggleModal(ModalEvents.AccessModal, {
      currentBoard: board ?? {},
    });
  };

  return (
    <div className="d-flex justify-content-between my-3">
      <div className="w-100">
        <TaskTypeHeaderBoardInformation board={board} />
      </div>
      <div className="w-100 d-flex justify-content-end">
        {boardPermissions && (
          <div className="mt-1">
            <AvatarGroup
              id={
                "dd_settings_board-settings_title-row_board-permissions-avatar-group-button"
              }
              total={
                boardPermissions?.Entities?.length
                  ? `${usersBoardPermissions} ${t(
                      "Boards:Users"
                    )} ${groupsBoardPermissions} ${t("Boards:Groups")}`
                  : 0
              }
              onClick={onClickOpenAccessModal}
              max={3}
            >
              {boardPermissions?.Entities.map((user, index) => (
                <Avatar
                  key={index}
                  content={user.FullName ?? user.Name}
                ></Avatar>
              ))}
            </AvatarGroup>
          </div>
        )}
        <div className="vertical-divider"></div>
        <div>
          <IconDropDownButton
            id={"dd_settings_board-settings_title-row_actions-dropdown"}
            iconCss="fa-regular fa-ellipsis-vertical"
            className="header-button"
            select={onSelectDropDownTaskMenu}
            items={dropdownMenu}
          />
        </div>
      </div>
    </div>
  );
};
